module.exports = __webpack_public_path__ + "static/scholle2_mini-72b0cec8e9914e5cb7ec6b9145a4d439.png";